import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button, Row, Col, notification } from "antd";
import {
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { updateFinalConditionApi } from "../../../../api/finalCondition";
import { getAccessToken } from "../../../../api/auth";

import "./EditFinalConditionForm.scss";

export default function EditFinalConditionForm(props) {
  const { finalCondition, setIsVisibleModal, setReloadFinalConditions } = props;
  const [finalConditionData, setFinalConditionData] = useState({});

  //trae los datos de condicion final
  useEffect(() => {
    setFinalConditionData({
      finalCondition_code: finalCondition.finalCondition_code,
      description: finalCondition.description,
    });
  }, [finalCondition]);

  //Verifica que no exista errores en los datos que se deben validar
  const isFormValid = (e) => {
    let errorExists = false;
    if (!finalConditionData.description) {
      notification["error"]({
        message: "Obligatorio: descripción.",
      });
      errorExists = true;
    } else {
      errorExists = false;
    }
    return errorExists;
  };

  const updateFinalCondition = (e) => {
    e.preventDefault();
    const error = isFormValid();
    if (!error) {
      const token = getAccessToken();
      let finalConditionUpdate = finalConditionData; //es let porque se va actualizando

      updateFinalConditionApi(
        token,
        finalConditionUpdate,
        finalCondition._id
      ).then((result) => {
        if (
          result.message === "ERR_CONNECTION_REFUSED" ||
          result.message === "Failed to fetch" ||
          result.message === undefined
        ) {
          notification["error"]({
            message: "Servidor caido",
          });
          setIsVisibleModal(true);
        } else if (result.code !== 200) {
          notification["error"]({
            message: result.message,
          });
          setIsVisibleModal(true);
        } else {
          notification["success"]({
            message: result.message, //el mensaje que viene del server
          });
          //console.log("respuesta: " + result.message);
          setIsVisibleModal(false);
          setReloadFinalConditions(true);
        }
      });
    }
  };

  return (
    <div className="edit-finalcondition-form">
      <EditForm
        finalConditionData={finalConditionData}
        setFinalConditionData={setFinalConditionData}
        updateFinalCondition={updateFinalCondition}
      />
    </div>
  );
}

function EditForm(props) {
  const { finalConditionData, setFinalConditionData, updateFinalCondition } =
    props;

  return (
    <Form className="form-edit" onSubmit={updateFinalCondition}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <label className="control-label">Código</label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={finalConditionData.finalCondition_code}
              onChange={(e) =>
                setFinalConditionData({
                  ...finalConditionData,
                  finalCondition_code: e,
                })
              }
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label">
            <span className="control-required">* </span>Descripción
          </label>
          <Form.Item>
            <Input
              //   placeholder="descripción"
              value={finalConditionData.description}
              onChange={(e) =>
                setFinalConditionData({
                  ...finalConditionData,
                  description: e.target.value,
                })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={updateFinalCondition}
        >
          Actualizar
        </Button>
      </Form.Item>
    </Form>
  );
}
